<template>
        <!-- footer-sec -->
    <section class="footer-sec">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="bripl-logo mb-3">
              <img src="@/assets/images/bripl-logo.png" class="rounded-full" alt="" width="70px" />
            </div>
            <div class="">
              <p>
                Bhima Riddhi Infotainment Pvt Ltd (BRIPL) business of operating Cable Television Networks in Kolhapur, Ichhakaranji, Satara and Sangli District other cities under the brand name “Bhima”(BRI)
              </p>
            </div>
          </div>
          <!--  -->
          <div class="col-lg-2 col-md-6 col-sm-12">
            <div class="Our-Address-title">
              <h4>Company</h4>
            </div>
            <ul class="office-address">
              <li class="list-style-icon">
                <span>Home</span>
              </li>
              <li class="list-style-icon">
                <span>Packages</span>
              </li>
              <li class="list-style-icon">
                <span>DAS License</span>
              </li>
              <li class="list-style-icon">
                <router-link :to="{name: 'TermsOfUse'}" >T & C</router-link>
              </li>
              <li class="list-style-icon">
                <span>Contact</span>
              </li>
            </ul>
          </div>
          <!--  -->
          <div class="col-lg-2 col-md-6 col-sm-12">
            <div class="Our-Address-title">
              <h4>Services</h4>
            </div>
            <ul class="office-address">
              <li class="list-style-icon">
                <span>Digital Cable</span>
              </li>
              <li class="list-style-icon">
                <span>Internet</span>
              </li>
              <li class="list-style-icon">
                <span>Broadband</span>
              </li>
              <li class="list-style-icon">
                <!-- <span>Regulatory</span> -->
                <span><a :href="`${publicPath}LCO_AGREEMENT.pdf`" download="Regulatory" style="color: inherit;">Regulatory</a></span>
              </li>
            </ul>
          </div>
          <!--  -->
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="Our-Address-title">
              <h4>Our-Address</h4>
            </div>
            <ul class="office-address">
              <li class="list-style-icon">
                <div class="add d-flex">
                  <div class="mrg-icon">
                    <img
                      src="@/assets/images/placeholder.svg"
                      width="30px"
                      alt=""
                    />
                  </div>
                  <span
                    >446/5, E Ward, Kailash Tower, 3rd Floor, Station Road,
                    Shahupuri , Kolhapur- 416001</span
                  >
                </div>
              </li>
              <li class="list-style-icon">
                <div class="add d-flex">
                  <div class="mrg-icon">
                    <img src="@/assets/images/email.svg" width="20px" alt="" />
                  </div>
                  <span> bhimariddhicustomercare@gmail.com​</span>
                </div>
              </li>
              <li class="list-style-icon">
                <div class="add d-flex">
                  <div class="mrg-icon">
                    <img
                      src="@/assets/images/phone-call.svg"
                      width="20px"
                      alt=""
                    />
                  </div>
                  <span>7387126704, 7755982688</span>
                </div>
              </li>
              <li class="list-style-icon">
                <div class="add d-flex">
                  <div class="mrg-icon">
                    <img
                      src="@/assets/images/phone-call.svg"
                      width="20px"
                      alt=""
                    />
                  </div>
                  <span>0231-2656977</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!--  -->
        <div class="footer-bottom-sec">
          <div class="border-bottom"></div>
          <!--  -->

          <div class="col-lg-6 col-md-6 col-sm-12 pl-0">
            <div class="copyright-text mt-3">
              <h5>© Bhima Riddhi Infotainment Pvt Ltd (BRIPL)</h5>
            </div>
          </div>
          <!--  -->
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="social-icon">
              <img src="" alt="" />
            </div>
          </div>
          <!--  -->
        </div>
      </div>
    </section>
</template>
<script>
export default {
      data () {
  return {
  publicPath: process.env.BASE_URL
  }
  }
}
</script>
<style>

</style>